import { useLocation, useNavigate } from "react-router";
import type { InvestorBankAccountDetails } from "../../../../api/types/bankAccountTypes";
import useClientContext from "../../../../contexts/useClientContext";
import { pageRoutes } from "../../../../routes";

interface NewBankAccountPageLocationState {
  availableFundInvestorIds: string[];
}

interface ChangeFundAssignmentsPageNavigationState {
  fundInvestorId: string;
  fundName: string;
  bankAccountId: string;
  bankAccounts: InvestorBankAccountDetails[];
}

export const useBankSettingsNavigation = () => {
  const { clientCode } = useClientContext();
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToBankAccountsPage = () => navigate(`/${clientCode}/${pageRoutes.settings}/lp/bank`);

  const navigateToNewBankAccountPage = (navigationState: NewBankAccountPageLocationState) => {
    navigate(`/${clientCode}/${pageRoutes.settings}/lp/bank/new`, { state: navigationState });
  };

  const navigateToChangeFundAssignmentsPage = (navigationState: ChangeFundAssignmentsPageNavigationState) => {
    navigate(`/${clientCode}/${pageRoutes.settings}/lp/bank/assign`, { state: navigationState });
  };

  const newBankAccountPageNavigationState = location.state as NewBankAccountPageLocationState | null;
  const changeFundAssignmentsPageNavigationState = location.state as ChangeFundAssignmentsPageNavigationState | null;

  return {
    navigateToBankAccountsPage,
    navigateToNewBankAccountPage,
    navigateToChangeFundAssignmentsPage,
    newBankAccountPageNavigationState,
    changeFundAssignmentsPageNavigationState,
  };
};
